import * as React from 'react'
import { DestructuredURL, DVString, APIClient, safeBool } from 'DVWebNodeUtils';
import { Icon, IconType, BaseComponentProps } from 'DVWebNodeUI'
import * as styles from './WatchlistStatus.module.scss'
import { Tooltip } from './Tooltip'

interface WatchlistStatusProps extends BaseComponentProps {
  watchlistAction: watchlistEndpointResponseAction
  onToggle?: (newAction: watchlistEndpointResponseAction) => void
}

interface WathlistStatusState {
  endpointPartialURL: string
  hasMounted: boolean
  isOnWatchlist: boolean
  endpointQuery: { [key: string]: string }
  text?: DVString
  tag?: string
  endpoint?: DestructuredURL
  ajaxEnabled?: boolean
}

interface watchlistEndpointResponseAction {
  text: DVString
  tag: string
  endpoint: DestructuredURL
  ajaxEnabled: boolean
}

interface watchlistEndpointResponse {
  watchlistAction: watchlistEndpointResponseAction
}

const isAlreadyOnWatchlist = (watchlistTag: string) => watchlistTag.toLowerCase() == 'remove'

const serializeFormdata = (object: any) => {
  let output = ''
  let index = 0
  const dilimiter = () => (index++ ? '&' : '?')

  for (const prop in object) {
    if (object.hasOwnProperty(prop)) {
      switch (Object.prototype.toString.call(object[prop])) {
        case '[object Array]':
          for (const prop2 in object[prop]) {
            if (object[prop].hasOwnProperty(prop2)) {
              output += `${dilimiter()}${prop}[]=${encodeURIComponent(object[prop][prop2])}`
            }
          }
          break
        case '[object Object]':
          for (const prop3 in object[prop]) {
            if (object[prop].hasOwnProperty(prop3)) {
              output += `${dilimiter()}${prop}[${prop3}]=${encodeURIComponent(object[prop][prop3])}`
            }
          }
          break
        default:
          output += `${dilimiter()}${prop}=${encodeURIComponent(object[prop])}`
      }
    }
  }

  return output
}

class WatchlistStatus extends React.Component<WatchlistStatusProps, WathlistStatusState> {
  ajaxEnabled: boolean
  buttonRef: React.RefObject<HTMLButtonElement>

  constructor(props: WatchlistStatusProps) {
    super(props)
    this.state = {
      isOnWatchlist: props && props.watchlistAction &&
        (isAlreadyOnWatchlist(props.watchlistAction.tag)),
      endpointPartialURL: props && props.watchlistAction &&
        props.watchlistAction.endpoint.partialURL,
      endpointQuery: props && props.watchlistAction && props.watchlistAction.endpoint.query,
      hasMounted: false
    }
    this.ajaxEnabled = props && props.watchlistAction &&
      safeBool(props.watchlistAction.ajaxEnabled)
    this.sendToggleRequest = this.sendToggleRequest.bind(this)
    this.buttonRef = React.createRef()
  }


  sendToggleRequest = () => {
    if (!this.ajaxEnabled) {
      return
    }
    const query = this.state.endpointQuery
    const watchlistParams = serializeFormdata(query)
    const api = new APIClient
    api.call(this.state.endpointPartialURL, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-requested-with': 'XMLHttpRequest' // must be there for WPS not to do the redirect
      },
      body: watchlistParams
    }).then((json: watchlistEndpointResponse) => {
      const action = json.watchlistAction || false
      if (action && action.endpoint) {
        this.setState({
          text: action.text,
          endpointPartialURL: action.endpoint.partialURL,
          endpointQuery: action.endpoint.query,
          isOnWatchlist: isAlreadyOnWatchlist(action.tag),
        })
      }
      if (this.props.onToggle)
        this.props.onToggle(json.watchlistAction)

    })
    this.buttonRef.current.blur()

  }

  componentDidMount() {
    this.setState({ hasMounted: true })
  }

  render() {
    if (!this.state.endpointPartialURL) {
      return null
    }
    const ariaLabel = (this.state.text && this.state.text.string) ||
      (this.props.watchlistAction && this.props.watchlistAction.text &&
        this.props.watchlistAction.text.string)

    return (
      <Tooltip text={(this.state.text && this.state.text.string) || this.props.watchlistAction.text.string}>
        <button
          onClick={this.sendToggleRequest}
          aria-label={ariaLabel}
          ref={this.buttonRef}
          className={styles.button}
        > {(this.state.isOnWatchlist
          ? <Icon use={IconType.WATCHLIST_ON} className={this.props.className} />
          : <Icon use={IconType.ADD} className={this.props.className} />)
          }
        </button>
      </Tooltip>
    )
  }
}
export default WatchlistStatus
